import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "footer py-4 d-flex flex-lg-column",
  id: "kt_footer"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-dark order-2 order-md-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold me-1" }, "© 2022 "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://tridentassistance.com/",
    target: "_blank",
    class: "text-gray-800 text-hover-primary"
  }, "Wyzard Systems"),
  /*#__PURE__*/_createTextVNode(" All rights reserved ")
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex flex-column flex-md-row align-items-center justify-content-between", {
        'container-fluid': _ctx.footerWidthFluid,
        'container-xxl': !_ctx.footerWidthFluid,
      }])
    }, _hoisted_3, 2)
  ]))
}